module.exports = __webpack_public_path__ + "img/banner1.7b78aa16.png";